const DEFAULT_MATTER_TEMPLATE_FIELD_DATA = {
  createNewMatter: {
    form_name: "Create New Matter",
    sections: [],
  },
  quickCreateNewMatter: {
    form_name: "Quick Create New Matter",
    sections: [],
  },
  unUsedFieldsTypes: [],
  usedFieldsTypes: [],
};

const deepClone = (value) => JSON.parse(JSON.stringify(value));

export const normalizeMatterTemplateFieldData = (fieldData) => {
  let normalizedSource = fieldData;

  if (Array.isArray(normalizedSource)) {
    normalizedSource =
      normalizedSource.length > 0 &&
      normalizedSource[0] &&
      typeof normalizedSource[0] === "object"
        ? normalizedSource[0]
        : {};
  }

  if (!normalizedSource || typeof normalizedSource !== "object") {
    normalizedSource = {};
  }

  const normalized = {
    ...deepClone(DEFAULT_MATTER_TEMPLATE_FIELD_DATA),
    ...normalizedSource,
  };

  if (
    !normalized.createNewMatter ||
    typeof normalized.createNewMatter !== "object"
  ) {
    normalized.createNewMatter = deepClone(
      DEFAULT_MATTER_TEMPLATE_FIELD_DATA.createNewMatter,
    );
  }

  if (
    !normalized.quickCreateNewMatter ||
    typeof normalized.quickCreateNewMatter !== "object"
  ) {
    normalized.quickCreateNewMatter = deepClone(
      DEFAULT_MATTER_TEMPLATE_FIELD_DATA.quickCreateNewMatter,
    );
  }

  normalized.createNewMatter = {
    ...deepClone(DEFAULT_MATTER_TEMPLATE_FIELD_DATA.createNewMatter),
    ...normalized.createNewMatter,
    sections: Array.isArray(normalized.createNewMatter.sections)
      ? normalized.createNewMatter.sections
      : [],
  };

  normalized.quickCreateNewMatter = {
    ...deepClone(DEFAULT_MATTER_TEMPLATE_FIELD_DATA.quickCreateNewMatter),
    ...normalized.quickCreateNewMatter,
    sections: Array.isArray(normalized.quickCreateNewMatter.sections)
      ? normalized.quickCreateNewMatter.sections
      : [],
  };

  normalized.unUsedFieldsTypes = Array.isArray(normalized.unUsedFieldsTypes)
    ? normalized.unUsedFieldsTypes
    : [];
  normalized.usedFieldsTypes = Array.isArray(normalized.usedFieldsTypes)
    ? normalized.usedFieldsTypes
    : [];

  return normalized;
};

export const resolveMatterTemplateCustomField = (record) => {
  const customFields = Array.isArray(record?.custom_fields)
    ? record.custom_fields
    : [];

  const withSections = customFields.find((field) => {
    const normalized = normalizeMatterTemplateFieldData(field?.field_data);
    return normalized.createNewMatter.sections.length > 0;
  });

  return (
    withSections ||
    customFields.find((field) => field?.field_for === "case") ||
    customFields[0] ||
    null
  );
};

export const resolveMatterTemplateFieldData = (record) =>
  normalizeMatterTemplateFieldData(
    resolveMatterTemplateCustomField(record)?.field_data,
  );

export const resolveMatterTemplateSections = (
  record,
  formKey = "createNewMatter",
) => resolveMatterTemplateFieldData(record)?.[formKey]?.sections || [];

export const hasMatterTemplateSections = (record, formKey = "createNewMatter") =>
  resolveMatterTemplateSections(record, formKey).length > 0;
